import { Component, Input, OnInit } from "@angular/core";
import { B29IdentityClientServer } from "./_services/b29.common.server";

@Component({
    selector: "app-api-frame",
    template: ''
})
export class ApiFrameComponent implements OnInit {
    @Input() siteId?: string;

    private channel: MessageChannel;
    b29IdentityClientServer: B29IdentityClientServer;

    constructor() {
        this.channel = new MessageChannel();
        this.b29IdentityClientServer = new B29IdentityClientServer(this.channel.port1);
    }

    ngOnInit() {
        console.log("ApiFrameComponent initialized with siteId:", this.siteId);
        window.parent.postMessage("init", "*", [this.channel.port2]);
        this.channel.port1.onmessage = (event) => {
            console.log('Received message from parent:', event.data);
        };
    }
}


